export default __webpack_public_path__ + "9ebb3d2b36d1df45c1bf2acccd4036a6.wav";